// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2429":"4a080890019e0915","2888":"f742ab1547395712","6230":"4a080890019e0915","7727":"4a080890019e0915"}[chunkId] + ".css";
};